import Dashboard from "./dashboard"
const dashboardRoutes = [
    {
        path: "/core/dashboard",
        element: <Dashboard />,
    },
]
export default dashboardRoutes